import cx from 'classnames';

// Utils
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  getButtonStylesAsClassName,
} from '@components/button';

export const getLinkStylesAsClassName = (
  dark?: boolean,
  color?: ButtonColor
): string => {
  return cx(
    'font-bold',
    'underline',
    'hover:cursor-pointer',
    'focus:cursor-pointer',
    // Focus-visible styles for keyboard accessibility
    'focus-visible:outline',
    'focus-visible:outline-2',
    'focus-visible:outline-offset-2',
    'rounded-sm', // Slight rounding for focus outline
    {
      'text-gray-main hover:text-gray-dark focus:text-gray-dark active:text-gray-xlight focus-visible:outline-gray-dark':
        color === 'gray',
      'text-primary-main hover:text-primary-dark focus:text-primary-dark active:text-primary-xlight focus-visible:outline-primary-dark':
        color === 'primary',
      'text-white hover:text-white focus:text-white active:text-white focus-visible:outline-white':
        !color && dark,
      // Default link color (no specific color prop)
      'text-primary-main hover:text-primary-dark focus:text-primary-dark active:text-primary-dark focus-visible:outline-primary-dark':
        !color && !dark,
    }
  );
};

export const getLinkButtonStylesAsClassName = (
  isFullWidth: boolean,
  color: ButtonColor,
  size: ButtonSize,
  variant: ButtonVariant,
  isLoading: boolean,
  isDisabled: boolean
): string =>
  getButtonStylesAsClassName({
    isFullWidth: isFullWidth,
    color: color,
    size: size,
    variant: variant,
    disabled: isDisabled,
    isLoading: isLoading,
  });
